import { render, staticRenderFns } from "./BlowMoldingMachineDetails.vue?vue&type=template&id=45294695&"
import script from "./BlowMoldingMachineDetails.vue?vue&type=script&lang=js&"
export * from "./BlowMoldingMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlowMoldingMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports